import { DesignPriceCalculatorRuleBased } from '../../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased';
import { Item } from '../models';
import { Integration, PlatformAttributeSelection } from './Integration';

enum MessageType {
	AddToCart = 'AddToCart',
	Price = 'Price',
	Close = 'Close',
	SharedComposition = 'SharedComposition'
}

export default class MerchantIntegrationGeneric implements Integration {
	private readonly callbacks = new Map();
	private messageIds = 0;

	private pricingCalculator: DesignPriceCalculatorRuleBased | null = null;

	public constructor() {
		window.addEventListener('message', (event) => {
			const eventType = event.data.zakekeMessageType;
			if (eventType === MessageType.Price || eventType === MessageType.SharedComposition) {
				const messageId = event.data.messageId;
				if (!this.callbacks.has(messageId)) {
					return;
				}
				const callback = this.callbacks.get(messageId);
				this.callbacks.delete(messageId);
				callback(event.data.message);
			}
		});
	}

	addToCart(
		composition: any,
		design: any,
		model: any,
		attributes: PlatformAttributeSelection[],
		designItems: Item[],
		quantity: number,
		additionalProperties: any
	) {
		let designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
		if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;

		window.parent.postMessage(
			{
				zakekeMessageType: MessageType.AddToCart,
				message: {
					composition: composition.id,
					design: design?.id,
					preview: composition.get('previewImageUrl'),
					designPrice,
					attributes,
					designItems,
					quantity,
					additionalProperties
				}
			},
			'*'
		);
	}

	getPrice(
		composition: any,
		design: any,
		model: any,
		attributes: any,
		compositionPrice: any,
		isCustomPricingConfiguratorEnabled: any,
		isCustomPricingRuleBasedEnabled: any,
		quantity: number
	) {
		return new Promise<number>((resolve, reject) => {
			const messageId = this.messageIds++;
			this.callbacks.set(messageId, resolve);

			console.log('Calculating price...');

			let designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
			let conditions = this.pricingCalculator && design ? this.pricingCalculator.getMatchedConditions(design, quantity, true) : [];

			// Subscription does not contain custom price
			if (!isCustomPricingRuleBasedEnabled) {
				designPrice = 0;
				conditions = [];
			}

			if (!isCustomPricingConfiguratorEnabled) compositionPrice = 0;

			console.log('Calculated Zakeke price:');
			console.log('- Composition price: ' + compositionPrice);
			if (compositionPrice !== 0) if (quantity > 1) compositionPrice = compositionPrice / quantity;
			if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;

			console.log('- Design price: ' + designPrice);
			window.parent.postMessage(
				{
					zakekeMessageType: MessageType.Price,
					messageId,
					message: {
						attributes,
						compositionPrice: compositionPrice + designPrice,
						designPrice,
						conditions,
						quantity
					}
				},
				'*'
			);
		});
	}

	getSharedCompositionUrl(compositionDocID: string) {
		return new Promise<{ url: string }>((resolve, reject) => {
			const messageId = this.messageIds++;
			this.callbacks.set(messageId, resolve);
			window.parent.postMessage(
				{
					zakekeMessageType: MessageType.SharedComposition,
					messageId,
					message: {
						compositionDocID
					}
				},
				'*'
			);
		});
	}

	close() {
		window.parent.postMessage(
			{
				zakekeMessageType: MessageType.Close
			},
			'*'
		);
	}

	setPricingCalculator(pricingCalculator: DesignPriceCalculatorRuleBased) {
		this.pricingCalculator = pricingCalculator;
	}
}
